import React from 'react';
import { pathOr } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import NotListedLocationOutlined from '@material-ui/icons/NotListedLocationOutlined';
import { useTranslation } from 'react-i18next';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import ChatPresenter from 'presenters/ChatPresenter';
import MessagePresenter from 'presenters/MessagePresenter';
import LoanOfficerCard from 'sharedComponents/LoanOfficerCard';
import Tooltip from 'sharedComponents/Tooltip';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import useStyles from './useStyles';

const LoanOfficersChatList = props => {
  const classes = useStyles();
  const { usersOnlineStatusList } = useFirebaseChat();
  const { selectedChatUid, onChatSelect, chats, chatsInfo } = props;
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Tooltip
        arrow
        header={t('components.LoanOfficerChatList.nextStepsTooltipHeader')}
        body={t('components.LoanOfficerChatList.nextStepsTooltip1')}
        body2={t('components.LoanOfficerChatList.nextStepsTooltip2')}
        body3={t('components.LoanOfficerChatList.nextStepsTooltip3')}
      >
        <div className={classes.nextBox}>
          <Typography variant="h2" noWrap className={classes.nextStepsHeader}>
            <NotListedLocationOutlined className={classes.nextIcon} />{' '}
            {t('components.LoanOfficerChatList.nextStepsHeader')}
          </Typography>
        </div>
      </Tooltip>

      {chats.map(chat => {
        const chatUid = FirebaseChatPresenter.uid(chat);
        const loanOfficerId = FirebaseChatPresenter.loanOfficerId(chat);
        const selectedChatInfo = chatsInfo[chatUid];
        const loanOfficer = isBlank(selectedChatInfo) ? null : ChatPresenter.loanOfficer(selectedChatInfo);
        const latestMessage = FirebaseChatPresenter.latestMessage(chat);
        const lastEventAt = MessagePresenter.formatedSentTimeFromNow(latestMessage);
        const unreadChatCount = FirebaseChatPresenter.unreadCount(chat);
        const isSelected = selectedChatUid === chatUid;
        const isOnline = pathOr(false, [loanOfficerId, 'isOnline'], usersOnlineStatusList);
        const latestBid = FirebaseChatPresenter.latestBid(chat);

        return (
          <LoanOfficerCard
            key={chatUid}
            isOnline={isOnline}
            isHightlighted={isSelected}
            lastEventAt={lastEventAt}
            unreadCount={unreadChatCount}
            loanOfficerId={loanOfficerId}
            onClick={() => onChatSelect(chatUid)}
            latestMessage={latestMessage}
            loanOfficer={loanOfficer}
            bid={latestBid}
            chat={chat}
          />
        );
      })}
    </Box>
  );
};

LoanOfficersChatList.propTypes = {
  chats: PropTypes.arrayOf(FirebaseChatPresenter.shape()).isRequired,
  selectedChatUid: PropTypes.string,
  onChatSelect: PropTypes.func.isRequired,
  chatsInfo: PropTypes.shape().isRequired,
};

LoanOfficersChatList.defaultProps = {
  selectedChatUid: '',
};

export default LoanOfficersChatList;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficersChatList/LoanOfficersChatList.js